import RoutesInterface from './RoutesInterface';
import { RoutesInterfaceType } from '@clientos/types';

let routesInterface: RoutesInterface;

export function getRoutesInterface(): RoutesInterface {
  return routesInterface;
}

export default async function initializeRoutesInterface(): Promise<RoutesInterfaceType> {
  if (routesInterface) return routesInterface.getInterface();

  routesInterface = new RoutesInterface();

  return routesInterface.getInterface();
}
